// Energiatehokkuus — extends LensTopicSection: kanta/salkku is the shared opportunity
// overview; building scope is the autonomous loop workspace (owns header + snapshot ribbon).
import { OptimizationBuildingSection } from "@/components/control-tower/perspectives/building/OptimizationBuildingSection";
import { LensTopicSection } from "@/components/control-tower/perspectives/LensTopicSection";
import { OPPORTUNITY_FINDINGS_FILTER } from "@/components/control-tower/perspectives/lens-topic-metrics";

export function EnergyEfficiencySection() {
  return (
    <LensTopicSection
      eyebrow="Energiatehokkuus · näkymä"
      title="Missä optimointi tarvitsee huomiota"
      description="Reseptit ja mahdollisuudet · autonominen silmukka strategian rajoissa"
      tracks={[
        {
          id: "opportunity",
          filter: OPPORTUNITY_FINDINGS_FILTER,
          label: "Mahdollisuus",
          summaryOptions: {
            okHint: "ei avoimia mahdollisuuksia",
            openHint: "avoimia mahdollisuuksia",
          },
          activityCategories: ["Optimointi", "Analytiikka"],
          findingsList: {
            ...OPPORTUNITY_FINDINGS_FILTER,
            emptyMessage: "Ei avoimia mahdollisuushavaintoja.",
          },
          subHeaderSuffix: "energiatehokkuus",
          overviewCopy: {
            situationCardSubtitle: (count) =>
              count === 1
                ? "1 kiinteistössä avoimia mahdollisuuksia"
                : `${count} kiinteistössä avoimia mahdollisuuksia`,
            situationCardAllDoneLabel: "Ei avoimia mahdollisuuksia",
            emptyScopeHint: "Ei kiinteistöjä valitulla rajauksella",
            tileCompleteLabel: "Kunnossa",
            mapTitle: "Energiatehokkuuden kartta",
            mapSubtitle:
              "Missä on eniten avoimia mahdollisuuksia — pallon koko = kiinteistöjä joilla avoimia havaintoja",
            mapLegendOkLabel: "Kunnossa",
            mapLegendWarnLabel: "Avoimia mahdollisuuksia",
          },
        },
      ]}
      renderBuildingWorkspace={(buildingId) => (
        <OptimizationBuildingSection buildingId={buildingId} />
      )}
    />
  );
}
